import { jsxs as o, jsx as n, Fragment as i } from "react/jsx-runtime";
import { NeuIcon as f } from "@hcahealthcaredpx/neutron-react";
const x = ({
  city: r,
  className: s,
  postalCode: a,
  state: c,
  street1: l,
  street2: m,
  title: d,
  titleClassName: u,
  icon: e = !1
}) => !l && !m && !r && !c && !a ? null : /* @__PURE__ */ o("div", { className: s, children: [
  d ? /* @__PURE__ */ n("p", { className: u, children: d }) : null,
  e && /* @__PURE__ */ n(f, { name: "location_on", className: "pe-1" }),
  l && /* @__PURE__ */ o(i, { children: [
    l,
    /* @__PURE__ */ n("br", {})
  ] }),
  m && /* @__PURE__ */ o(i, { children: [
    m,
    /* @__PURE__ */ n("br", {})
  ] }),
  r && `${r}, `,
  c,
  " ",
  a
] });
export {
  x as A
};
